export const CERTIFICATE_TYPES = {
    REFERENCE_ACCOUNTS: 'reference_accounts',
    CARD_DETAILS: 'card_details'
}
